import { useEffect, useState } from 'react';

type DirectionType = 'asc' | 'desc';

interface UseDataTableSortProps {
  defaultField?: string;
  defaultDirection?: DirectionType;
  resetPagination?: () => void;
}
export interface UseDataTableSortResponse {
  onSortChange: (value: string) => void;
  sortField: string;
  sortDirection: DirectionType;
}

export const useDataTableSort = ({
  defaultField,
  defaultDirection,
  resetPagination,
}: UseDataTableSortProps) => {
  const [field, setField] = useState<string>(defaultField || 'id');
  const [direction, setDirection] = useState<DirectionType>(
    defaultDirection || 'asc'
  );
  const disableAutoChangeDirection = !!defaultDirection;

  useEffect(() => {
    if (!disableAutoChangeDirection) {
      setDirection('asc');
    }
  }, [field, disableAutoChangeDirection]);

  const onSortChange = (value: string) => {
    resetPagination?.();
    if (value === field) {
      setDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setField(value);
    }
  };
  return {
    onSortChange,
    sortField: field,
    sortDirection: direction,
  };
};
